import http from '@/api/http'

const REQUEST_URL = '/message_template/'

export default {
  /**
   * テンプレート一覧の取得
   */
  fetchTemplates(params?: any): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post(REQUEST_URL, {
          page: 'get_init',
          ...params
        })
        .then(res => resolve(res.data))
        .catch(reject)
    })
  },

  /**
   * テンプレートの作成と編集
   */
  editTemplate(params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post(REQUEST_URL, {
          page: 'edit',
          ...params
        })
        .then(res => resolve(res.data))
        .catch(reject)
    })
  },

  /**
   * テンプレートの削除
   */
  removeTemplate(params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post(REQUEST_URL, {
          page: 'remove',
          ...params
        })
        .then(res => resolve(res.data))
        .catch(reject)
    })
  },

  /**
   * 自動入力設定
   */
  autoInput(params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post(REQUEST_URL, {
          page: 'auto_input',
          ...params
        })
        .then(res => resolve(res.data))
        .catch(reject)
    })
  }
}
